import { createSlice } from "@reduxjs/toolkit";

import { getResidenceInformationRes } from "core/http/service/personnelInformation/resTypes";

interface InitialState {
  currentData: getResidenceInformationRes;
  formData: getResidenceInformationRes;
  changedData: {
    [key: string]: any;
  };
}

const initialState: InitialState = {
  currentData: {
    residentProvinceCode: "",
    residentDistrictCode: "",
    residentWardCode: "",
    residentWardName: "",
    residentDistrictName: "",
    residentProvinceName: "",
    residentAddress: "",
    stayingProvinceCode: "",
    stayingDistrictCode: "",
    stayingWardCode: "",
    stayingWardName: "",
    stayingDistrictName: "",
    stayingProvinceName: "",
    stayingAddress: "",
  },
  formData: {
    residentProvinceCode: "",
    residentDistrictCode: "",
    residentWardCode: "",
    residentWardName: "",
    residentDistrictName: "",
    residentProvinceName: "",
    residentAddress: "",
    stayingProvinceCode: "",
    stayingDistrictCode: "",
    stayingWardCode: "",
    stayingWardName: "",
    stayingDistrictName: "",
    stayingProvinceName: "",
    stayingAddress: "",
  },
  changedData: undefined,
};

const formEditResidenceInformationSlice = createSlice({
  name: "editBankInformation",
  initialState,
  reducers: {
    updateFormEditResidenceInformation: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    updateCurrentData: (state, action) => {
      state.currentData = action.payload;
    },
    updateChangedData: (state, action) => {
      state.changedData = action.payload;
    },
    resetFormEditResidenceInformation: () => {
      return { ...initialState };
    },
  },
});

export const {
  updateChangedData,
  updateCurrentData,
  updateFormEditResidenceInformation,
  resetFormEditResidenceInformation,
} = formEditResidenceInformationSlice.actions;

export default formEditResidenceInformationSlice.reducer;
